<div *ngIf="isDev" class="banner">debug</div>

<ng-container *ngIf="appStatus.status$ | async as status">
  <div *ngIf="status === 'checking'" class="app-status-screen" role="status" aria-live="polite" aria-busy="true">
    <div class="app-status-content">
      <img src="assets/CTiGuard-Logo.svg" alt="CTiGuard Logo" width="160" height="64" class="app-status-logo" />
      <div class="app-loading-track" aria-hidden="true">
        <div class="app-loading-indicator"></div>
      </div>
      <span class="visually-hidden">Loading asset information...</span>
    </div>
  </div>

  <div *ngIf="status === 'unavailable'" class="app-status-screen" role="alert">
    <div class="app-status-content app-maintenance">
      <img src="assets/CTiGuard-Logo.svg" alt="CTiGuard Logo" width="160" height="64" class="app-status-logo" />
      <h1>System under maintenance.</h1>
      <p>We will be back online shortly!</p>
      <button type="button" (click)="retry()">Retry</button>
    </div>
  </div>

  <div *ngIf="status !== 'unavailable'" [hidden]="status !== 'available'" class="app-content">
    <router-outlet></router-outlet>
  </div>
</ng-container>
